"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var scatterjs_core_1 = __importDefault(require("scatterjs-core"));
var scatterjs_plugin_eosjs2_1 = __importDefault(require("scatterjs-plugin-eosjs2"));
var scatter = scatterjs_core_1.default.scatter;
var accountPublickey;
scatter.loadPlugin(new scatterjs_plugin_eosjs2_1.default());
function makeSignatureProvider(network) {
    // 3rd param: beta3 = true
    return scatter.eosHook(__assign({}, network, { blockchain: 'eos' }), null, true);
}
exports.makeSignatureProvider = makeSignatureProvider;
// TODO: Ability to pass Scatter options
function scatterWalletProvider() {
    return function makeWalletProvider(network) {
        // Connection
        function connect(appName) {
            return scatter.connect(appName, { initTimeout: 10000 }).then(function (connected) {
                if (connected)
                    return true;
                return Promise.reject('Cannot connect to Scatter');
            });
        }
        function discover(discoveryOptions) {
            // console.log('in scatter discover.');
            return new Promise(function (resolve, reject) {
                var discoveryInfo = {
                    keys: [],
                    note: 'Scatter does not support discovery'
                };
                resolve(discoveryInfo);
            });
        }
        function disconnect() {
            // TODO: Uncomment when Scatter implements this correctly
            // (probably by using `socket.close()` instead of `socket.disconnect()`)
            scatter.disconnect();
            return Promise.resolve(true);
        }
        // Authentication
        function login(accountName) {
            return __awaiter(this, void 0, void 0, function () {
                var identity, account, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            // Useful for testnets to provide a convenient means for the end use to quickly add
                            // the required network configuration to their Scatter seamlessly while logging in.
                            return [4 /*yield*/, scatter.suggestNetwork(__assign({}, network, { blockchain: 'eos' }))];
                        case 1:
                            // Useful for testnets to provide a convenient means for the end use to quickly add
                            // the required network configuration to their Scatter seamlessly while logging in.
                            _a.sent();
                            return [4 /*yield*/, scatter.getIdentity({
                                    accounts: [__assign({}, network, { blockchain: 'eos' })]
                                })];
                        case 2:
                            identity = _a.sent();
                            if (!identity) {
                                return [2 /*return*/, Promise.reject('No identity obtained from Scatter')];
                            }
                            account = (identity &&
                                identity.accounts &&
                                identity.accounts.find(function (x) { return x.blockchain === 'eos'; })) ||
                                void 0;
                            if (!account) {
                                return [2 /*return*/, Promise.reject('No account data obtained from Scatter identity')];
                            }
                            accountPublickey = account.publicKey;
                            return [2 /*return*/, {
                                    accountName: account.name,
                                    permission: account.authority,
                                    publicKey: accountPublickey
                                }];
                        case 3:
                            error_1 = _a.sent();
                            console.log('[scatter]', error_1);
                            return [2 /*return*/, Promise.reject(error_1)];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        function logout(accountName) {
            return scatter.forgetIdentity();
        }
        function signArbitrary(data, userMessage) {
            return scatter.getArbitrarySignature(accountPublickey, data, userMessage);
        }
        var walletProvider = {
            id: 'scatter',
            meta: {
                name: 'Scatter Desktop',
                shortName: 'Scatter',
                description: 'Scatter Desktop application that keeps your private keys secure'
            },
            signatureProvider: makeSignatureProvider(network),
            connect: connect,
            discover: discover,
            disconnect: disconnect,
            login: login,
            logout: logout,
            signArbitrary: signArbitrary
        };
        return walletProvider;
    };
}
exports.scatterWalletProvider = scatterWalletProvider;
exports.default = scatterWalletProvider;
// force rebuild 2
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/eos-transit-scatter-provider/lib/index.js
// module id = pX0Q
// module chunks = 6